import { Link } from 'react-router-dom';
import { useState } from 'react';
import useVendorOrders from '../../hooks/useVendorOrders';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function VendorOrders() {
    // Filter state
    const [orderId, setOrderId] = useState('');
    const [status, setStatus] = useState('');
    const [page, setPage] = useState(1);
    const perPage = 20;

    // Fetch vendor orders
    const { orders, pagination, isLoading, error } = useVendorOrders({
        query: {
            ...(orderId && { order_id: orderId }),
            ...(status && { status }),
        },
        page,
        perPage
    });

    const totalPages = pagination?.last_page || 1;

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    if (error) {
        return <div>Error loading orders: {error.message || 'Unknown error'}</div>;
    }

    return (
        <>
            <div className="container-fluid px-0">
                <div className="row g-0">
                    <div className="col-12">
                        <div className="card card-table">
                            <div className="card-body p-0">

                                {/* Header + Filters */}
                                <div className="title-header option-title d-flex justify-content-between align-items-center p-3">
                                    <h5 className="mb-0">Vendor Orders</h5>

                                    <div className="d-flex align-items-center" style={{ gap: 16 }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Filter by Order ID"
                                            value={orderId}
                                            onChange={e => setOrderId(e.target.value)}
                                            style={{ maxWidth: 160 }}
                                        />

                                        <select
                                            className="form-select"
                                            value={status}
                                            onChange={e => setStatus(e.target.value)}
                                            style={{ maxWidth: 140 }}
                                        >
                                            <option value="">All Statuses</option>
                                            <option value="pending">Pending</option>
                                            <option value="ongoing">Ongoing</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="table-responsive">
                                    <table className="table all-package order-table theme-table mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '10%' }}>Order ID</th>
                                                <th style={{ width: '15%' }}>Date</th>
                                                <th style={{ width: '15%' }}>Status</th>
                                                <th style={{ width: '10%' }}>Amount</th>
                                                <th style={{ width: '10%' }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center py-4">
                                                        <div className="spinner-border" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : orders.length === 0 ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center">No orders found.</td>
                                                </tr>
                                            ) : (
                                                orders.map((order) => {
                                                    const status = order.status || '-';
                                                    const amount = order.total_amount || '-';
                                                    const currency = order.order_items?.[0]?.currency_symbol || '-';
                                                    const date = order.ordered_at
                                                        ? new Date(order.ordered_at).toLocaleDateString()
                                                        : '-';

                                                    return (
                                                        <tr key={order.order_id}>
                                                            <td>{order.order_id}</td>
                                                            <td>{date}</td>

                                                            <td className={`order-${status.toLowerCase()}`}>
                                                                <span
                                                                    style={
                                                                        status === 'cancelled'
                                                                            ? {
                                                                                  display: 'inline-block',
                                                                                  backgroundColor: 'rgb(186 66 66 / 20%)',
                                                                                  color: '#e03131',
                                                                                  padding: '5px 6px',
                                                                                  borderRadius: '5px',
                                                                                  fontSize: '12px',
                                                                                  fontWeight: '700'
                                                                              }
                                                                            : {}
                                                                    }
                                                                >
                                                                    {status}
                                                                </span>
                                                            </td>

                                                            <td>{currency} {parseFloat(amount).toFixed(2)}</td>


                                                            <td style={{ textAlign: 'center' }}>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        gap: '8px'
                                                                    }}
                                                                >
                                                                    <Link
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        to={`/vendorOrderDetails/${order.order_id}`}
                                                                        title="View Details"
                                                                    >
                                                                        <VisibilityIcon fontSize="small" />
                                                                    </Link>

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                <nav className="d-flex justify-content-center mt-4">
                                    <ul className="pagination">
                                        <li className={`page-item${page === 1 ? ' disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(page - 1)}
                                                disabled={page === 1}
                                            >
                                                &laquo; Prev
                                            </button>
                                        </li>

                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                                            <li key={pg} className={`page-item${pg === page ? ' active' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageChange(pg)}>
                                                    {pg}
                                                </button>
                                            </li>
                                        ))}

                                        <li className={`page-item${page === totalPages ? ' disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(page + 1)}
                                                disabled={page === totalPages}
                                            >
                                                Next &raquo;
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
